import React from 'react';

import { usePageStore } from '@client/store/pageStore/context/pageContext';
import { Box, Grid } from '@mui/material';
import Typography from '@mui/material/Typography';

interface TitleAndDescriptionProps {
    titleAction?: React.ReactNode;
}

const TitleAndDescription = ({ titleAction }: TitleAndDescriptionProps) => {
    const {
        pageState: { pageConfig }
    } = usePageStore();

    return (
        <>
            <Grid item xs={12}>
                <Box sx={{ alignItems: 'center', display: 'flex', flexWrap: 'wrap', gap: 1, justifyContent: 'space-between' }}>
                    <Typography variant="h1">{pageConfig.title}</Typography>
                    {titleAction}
                </Box>
            </Grid>
            <Grid item xs={12}>
                <Typography variant="subtitle1">{pageConfig.description}</Typography>
            </Grid>
        </>
    );
};

export default TitleAndDescription;
